"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickTokensFromSearch = exports.BaseTokenEnum = void 0;
//@ts-ignore
const query_string_1 = require("query-string");
var BaseTokenEnum;
(function (BaseTokenEnum) {
    BaseTokenEnum["sfContactId"] = "sfContactId";
    BaseTokenEnum["workEmailRoleToken"] = "workEmailRoleToken";
    BaseTokenEnum["workEmailVerifyToken"] = "workEmailVerifyToken";
    BaseTokenEnum["authToken"] = "authToken";
    BaseTokenEnum["userSocialLinkToken"] = "userSocialLinkToken";
})(BaseTokenEnum || (exports.BaseTokenEnum = BaseTokenEnum = {}));
const pickTokensFromSearch = (locationSearch) => {
    const params = (0, query_string_1.parse)(locationSearch);
    const tokens = {};
    const possibleTokens = Object.keys(BaseTokenEnum);
    Object.keys(params).forEach((paramName) => {
        if (possibleTokens.indexOf(paramName) !== -1) {
            tokens[paramName] = params[paramName];
        }
    });
    return tokens;
};
exports.pickTokensFromSearch = pickTokensFromSearch;
//# sourceMappingURL=tokens.js.map